/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const language_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1.007 8.938H5.82c.613 0 1.185.446 1.334 1.04l.687 2.75c.051.204.055.415.011.62a1.392 1.392 0 0 1-1.344 1.09h-.99l-.529 2.647-.405 2.277m16.554-4.547a10.485 10.485 0 0 1-.953 1.96l3.083 6.475-6.474-3.083a10.58 10.58 0 0 1-9.327.878 10.5 10.5 0 0 1-2.883-1.683 10.556 10.556 0 0 1-3.433-5.238 10.52 10.52 0 0 1-.143-5.186m20.13 5.877a10.484 10.484 0 0 0-.692-8.678 10.339 10.339 0 0 0-1.768-2.324C16.729 1.887 14.055.746 11.267.75a10.5 10.5 0 0 0-4.686 1.095 10.577 10.577 0 0 0-5.574 7.093m20.13 5.877H17.37a1.388 1.388 0 0 1-1.357-1.148l-.725-4.354h-1.447c-.88 0-1.544-.868-1.334-1.71l.688-2.75a1.406 1.406 0 0 1 1.333-1.04h4.149"
    />
  </svg>
)
export default language_medium
